import type { settings as en } from '@/i18n/locales/en/settings';
import type { Translation } from '@/i18n/types';

export const settings: Translation<typeof en> = {
  title: 'Ayarlar',
  lead: 'Şirket profiliniz, markalaşma ve gizlilik ayarlarınız.',
  noCompany: 'Seçili aktif bir şirket yok.',
  adminOnly:
    'Bunu yalnızca bir platform yöneticisi değiştirebilir — mevcut değerleri görebilirsiniz.',
  save: 'Kaydet',
  nav: {
    label: 'Ayarlar menüsü',
    profile: 'Profil',
    branding: 'Markalaşma',
    privacy: 'Gizlilik',
    modules: 'Modüller',
  },
  profile: {
    title: 'Profil',
    name: 'Kuruluş adı',
    industry: 'Sektör',
    industryHint: 'Serbest metin, örn. "Lojistik" veya "Sağlık".',
    employeeCount: 'Çalışan sayısı',
    plan: 'Plan',
    planPlaceholder: 'Aboneliğe bakın',
  },
  branding: {
    title: 'Markalaşma',
    lead: 'Logonuz ve vurgu renginiz, canlı önizleme ile.',
    logo: 'Logo yükle',
    logoHint: 'Hemen yüklenir; veya aşağıya mevcut bir URL girin.',
    logoUrl: "Logo URL'si",
    upload: {
      uploading: 'Yükleniyor…',
      tooLarge: 'Dosya çok büyük (maks. 10MB).',
      invalidType: 'Dosya türüne izin verilmiyor.',
    },
    accentColor: 'Vurgu rengi',
    preview: 'Canlı önizleme',
    colors: {
      mint: 'Nane',
      pine: 'Çam',
      ink: 'Mürekkep',
      amber: 'Kehribar',
      coral: 'Mercan',
      sky: 'Gök mavisi',
    },
  },
  privacy: {
    title: 'Gizlilik',
    lead: 'Toplu istatistikler için minimum grup boyutu ve şirketinizin neyi paylaştığı.',
    minGroupSize: 'Minimum grup boyutu (k-anonimlik)',
    minGroupSizeHint: 'Bunun altında, bir grup toplu istatistik göstermek için çok küçüktür.',
    minGroupSizeValue: '{{count}} kişi',
    effective: 'Şu anda geçerli: {{count}} kişi',
    aggregatedData: 'Toplu veriler',
    aggregatedDataHint: 'Minimum boyuta ulaşan gruplar için toplu istatistikleri gösterin.',
    explicitConsent: 'Açık rıza gerekli',
    explicitConsentHint: 'Toplu rıza yerine bireysel bir rıza yanıtı isteyin.',
    dataExport: 'Veri dışa aktarma',
    dataExportHint: 'İstatistik verilerinin dışa aktarılmasına izin ver.',
    auditLogHint: 'Yönetimsel eylemler her zaman bir denetim kaydına kaydedilir.',
  },
  modules: {
    title: 'Modüller',
    lead: 'Şirketiniz için kullanılabilir modülleri etkinleştirin veya devre dışı bırakın.',
    vitality: 'Canlılık',
    vitalityHint: 'Uyku, stres, kalp hızı ve aktivite takibi.',
    participation: 'Katılım',
    participationHint: 'Katılım hunisi ve katılım metrikleri.',
    pilots: 'Pilot Programları',
    pilotsHint: 'Pilot programlarını çalıştırın ve takip edin.',
    challenges: 'Zorluklar',
    challengesHint: 'Sağlık zorlukları oluşturun ve yönetin.',
    communication: 'İletişim',
    communicationHint: 'Çalışanlara bildirimler ve mesajlar gönderin.',
    documents: 'Belgeler',
    documentsHint: 'Şirket belgelerini yayınlayın ve yönetin.',
    reports: 'Raporlar',
    reportsHint: 'Analitik raporlar oluşturun ve dışa aktarın.',
    ai_coach: 'Yapay Zeka Koçu',
    ai_coachHint: 'Yapay zeka destekli kişiselleştirilmiş koçluk.',
  },
};
